<template>
  <div>
    <el-upload
      drag
      multiple
      action=""
      :accept="fileTypeShow.accept"
      :http-request="uploadFile"
      :before-upload="fileBeforeUpload"
      :limit="fileNum"
      :file-list="fileList"
      :show-file-list="false"
      :on-exceed="handleExceed"
      class="w-full"
      v-if="!disabled"
    >
      <i class="el-icon-upload"></i>
      <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
      <div class="text-left" slot="tip">
        {{
          `支持${fileTypeShow.des}格式附件${
            fileMaxSize ? '，附件大小不能超过' + fileMaxSize + 'M' : ''
          }`
        }}
      </div>
    </el-upload>
    <div v-show="fileIdList.length" class="inline-block">
      <slot name="content">
        <div
          :key="index"
          v-for="(item, index) in fileIdList"
          class="p-0px hover:bg-slate-100 flex items-center"
        >
          <span class="cursor-pointer" @click="onPreview(item)">{{ item.fileName }}</span>
          <span class="ml-5px cursor-pointer" @click="viewFile(item)">
            <i class="icon-bg-display iconfont"></i>
          </span>
          <span class="ml-5px cursor-pointer" v-if="!disabled" @click="beforeRemove(item)">
            <i class="icon-bg-delete iconfont hover:text-hex-$buttonPrimaryBg hover:shadow"></i>
          </span>
        </div>
      </slot>
    </div>
    <el-image
      v-show="false"
      ref="elImage"
      :src="imgContent"
      :preview-src-list="[imgContent]"
    ></el-image>
  </div>
</template>

<script>
import { FileApi } from '@wiz-api/file-management'

const fileApi = new FileApi()

export default {
  name: 'upload-accident',
  data() {
    return {
      fileList: [], // 上传附件的列表
      fileIdList: [], // 上传成功文件的文件id
      fileMap: {}, // 上传成功文件名与文件id的映射
      imgContent: null,
    }
  },
  watch: {
    fileIdList: {
      handler(newValue) {
        this.$emit('update:file', newValue)
      },
      deep: true,
    },
  },
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    fileNum: {
      type: Number,
      default: 999,
    },
    fileTypeList: {
      type: Array,
      default: () => {
        return []
      },
    }, // 文件上传类型限制
    fileMaxSize: {
      type: Number,
      default: 0,
    }, // 文件上传大小限制
    delText: {
      typeof: String,
      default: '此操作将永久删除该文件, 是否继续?',
    },
  },
  computed: {
    fileTypeShow() {
      return this.fileTypeList.reduce(
        (pre, cur, index) => {
          return {
            accept: `${pre.accept}.${cur}${this.fileTypeList.length === index + 1 ? '' : ','}`,
            des: `${pre.des}${cur}${this.fileTypeList.length === index + 1 ? '' : ','}`,
          }
        },
        { accept: '', des: '' }
      )
    },
  },
  methods: {
    // 文件超出限制钩子
    handleExceed() {
      this.$message.warning('文件个数超出限制')
    },
    // 复现
    setFile(data) {
      this.fileIdList = data
      this.fileList = data
    },
    beforeRemove(file) {
      return this.$confirm(this.delText, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        callback: (action) => {
          if (action === 'confirm') {
            this.fileIdList = this.fileIdList.filter((i) => {
              return i.id !== file.id
            })
            this.fileList = this.fileIdList
            this.$emit('delete', file.id)
          }
        },
      })
    },
    onPreview(file) {
      this.downLoadFile(file)
    },
    // 附件，下载
    async downLoadFile(file) {
      const [err, res] = await fileApi.download(file.id, { returnType: 'Blob' })
      if (!err) {
        this.exportFile(res, file.fileName)
      }
    },
    // 下载文件
    exportFile(data, name) {
      const blob = new Blob([data], {
        type: 'application/pdf',
      })
      const blobUrl = window.URL.createObjectURL(blob)
      const templink = document.createElement('a')
      templink.style.display = 'none'
      templink.href = blobUrl
      templink.setAttribute('download', `${name}`)
      document.body.appendChild(templink)
      templink.click()
      document.body.removeChild(templink)
      window.URL.revokeObjectURL(blobUrl)
      this.$message({
        type: 'success',
        message: '下载成功!',
      })
    },
    // 查看文件
    async viewFile(file) {
      const [err, res] = await fileApi.download(file.id, { returnType: 'Blob' })
      const strList = file.fileName.split('.')
      const type = strList[strList.length - 1].toLowerCase()
      const typeMap = {
        pdf: 'application/pdf',
      }
      const imageList = ['jpg', 'png', 'jpg', 'jpeg', 'gif', 'psd', 'bmp', 'tiff']
      if (!typeMap[type] && !(imageList.indexOf(type) > -1)) {
        this.$message.warning('只支持pdf和图片预览')
        return
      }
      if (imageList.indexOf(type) > -1) {
        const [error, result] = await fileApi.getFileContent(file.id)
        if (!error) {
          this.imgContent = `data:image/jpg;base64,${result.content}`
        }
        this.$refs.elImage.clickHandler()
        return
      }
      if (!err) {
        // this.exportFile(res, file.name)
        const blob = new Blob([res], {
          type: 'application/pdf',
        })
        const blobUrl = window.URL.createObjectURL(blob)
        const templink = document.createElement('a')
        templink.style.display = 'none'
        templink.href = blobUrl
        templink.setAttribute('target', '_blank')
        document.body.appendChild(templink)
        templink.click()
        document.body.removeChild(templink)
        window.URL.revokeObjectURL(blobUrl)
      }
    },
    /**
     * @description 文件上传前回调,返回false停止上传
     */
    fileBeforeUpload(file) {
      const fileSize = Number(file.size / (1024 * 1024))
      if (this.fileMaxSize && fileSize > this.fileMaxSize) {
        this.$message.warning(`文件大小超过${this.fileMaxSize}M`)
        return false
      }
      const fileTypeList = file.name.split('.')
      const fileType = fileTypeList[fileTypeList.length - 1]
      if (this.fileTypeList.length && !this.fileTypeList.includes(fileType)) {
        this.$message.warning('上传文件格式不符合')
        return false
      }
      return true
    },
    /**
     * @description 文件上传
     */
    async uploadFile(file) {
      const formData = new FormData()
      formData.append('file', file.file)
      this.saveLoading = true
      const [err, res] = await fileApi.upload({
        files: [file.file],
      })
      this.saveLoading = false
      if (!err) {
        this.$message.success(this.$t('上传成功'))
        // this.fileList.push(res)
        this.fileIdList.push(Object.values(res)[0])
        this.fileMap = {
          ...this.fileMap,
          ...res,
        }
      }
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep .el-card__body {
  height: 100%;
}
::v-deep .el-tabs {
  height: calc(100% - 70px);
}
::v-deep .el-tabs__content {
  height: calc(100% - 55px);
  overflow-y: auto;
}
::v-deep .el-tab-pane {
  height: 100%;
}
::v-deep .el-form-item__label {
  text-align: right;
}
::v-deep .el-upload {
  width: 100%;
}
</style>
